import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { ISetOwnerParams } from '../../../ts/ServerApi/types/actionParams';

export class SetFlowsOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setFlowsOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
